import styled from 'styled-components';
import { Body2, spacing } from 'ui/theme';
import { Pagination } from 'ui/pagination';
import { PageSize } from 'ui/pageSize';
import { usePaginationContext } from 'utils/contexts/pagination';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${spacing.double};
`;

const Body2NoMargin = styled(Body2)`
  margin-bottom: 0;
`;

export const PaginationFooter = ({ rowsCount }: { rowsCount: number }) => {
  const { currentPage, pageSize, setPageSize, setCurrentPage } = usePaginationContext();

  return (
    <Wrapper>
      <Body2NoMargin>{rowsCount} total</Body2NoMargin>
      <Pagination
        page={currentPage}
        onChangePage={setCurrentPage}
        pages={Math.ceil(rowsCount / pageSize)}
      />
      <PageSize
        defaultSize={20}
        pageSizes={[20, 50, 100]}
        total={rowsCount}
        onSelect={setPageSize}
      />
    </Wrapper>
  );
};
